<ng-container *ngIf="styleReady">
  <router-outlet />
</ng-container>
